import { ETripEvent } from 'detailsv2/structure';

import { IDayTripEvent } from '../../../types';

const InformationOption = ({ data }: IDayTripEvent<ETripEvent.Information>) => {
  return <div>{data.title}</div>;
};

export default InformationOption;
